import { mapFilterTypesToFilterArgs } from "components/SharedTable/tableFilterOptionHelpers";

export function getCaseTableMappedFilterArgs(filters) {
  const filterTypesToArgsMap = {
    Priority: "priority_id__in",
    Status: "status__in",
    Site: "machine__site_id__in",
    Machine: "machine_id__in",
    Manufacturer: "manufacturer_id",
    Model: "model_id",
    Component: "component_id__in",
    "Failure Mode": "failure_mode_id__in",
    "Machine Status": "machine_status__in",
    "Next Action": "next_action__in",
    Diagnostic: "diagnostic_severity__in",
    Inspection: "inspection_severity__in",
    Assignee: "assignee_id__in",
    "Created by": "created_by__in",
    Outcome: "outcome__in",
    "Delay Reason": "delay_reason__in",
    Label: "labels"
  };

  return mapFilterTypesToFilterArgs(filters, filterTypesToArgsMap);
}

export function getCaseTableMappedSortArgs(sortBy) {
  // maps column headers to fields on case endpoint
  // if these are differnet from the sorting name.
  const sortTypesToArgsMap = {
    diagnostic_severity_name: "diagnostic_severity",
    inspection_severity_name: "inspection_severity",
    component_failure_mode: "component_name",
    site_machine: "site_name",
    machine_status_name: "machine_status",
    case_status_name: "status",
    last_updated: "change_date",
    priority_name: "priority_order",
    assignee_name: "assignee",
    created_by: "created_by",
    display_id: "id"
  };

  let mappedArgs = {};
  const updatedSortBy = [];

  sortBy.forEach(sort => {
    let sortId = sort.id;
    let sortByObj = sort;

    if (sortTypesToArgsMap[sortId]) {
      sortId = sortTypesToArgsMap[sortId];
      sortByObj = { ...sort, id: sortId };
    }

    // Combined header needs to have sorting of both column header fields
    // sort by component then failure mode if components match
    if (sort.id === "component_failure_mode") {
      updatedSortBy.push({ ...sort, id: "component_name", desc: sort.desc });
      updatedSortBy.push({ ...sort, id: "failure_mode_name", desc: sort.desc });
    }
    // sort by site then machine if site match
    else if (sort.id === "site_machine") {
      updatedSortBy.push({ ...sort, id: "site_name", desc: sort.desc });
      updatedSortBy.push({ ...sort, id: "machine_name", desc: sort.desc });
    } else {
      updatedSortBy.push(sortByObj);
    }
  });

  const tableOrdering = updatedSortBy.map(sort => {
    return sort.desc ? `-${sort.id}` : `${sort.id}`;
  });

  // Add id as final sorting field as this guarantees consistent sort across fields
  mappedArgs = { ordering: [...tableOrdering, "id"] };

  return mappedArgs;
}
